import React from "react";

export default function GraphicIcon() {
  return (
    <svg
      className="hover:text-darkblue"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M22 21.6742H1.86255V1.49922C1.86255 1.04922 1.48755 0.636719 1.00005 0.636719C0.512549 0.636719 0.175049 1.04922 0.175049 1.49922V21.7867C0.175049 22.6492 0.887549 23.3617 1.75005 23.3617H22C22.45 23.3617 22.8625 22.9867 22.8625 22.4992C22.8625 22.0117 22.45 21.6742 22 21.6742Z"
        fill="currentColor"
      />
      <path
        d="M21.625 8.28711H17.2375C16.7875 8.28711 16.375 8.66211 16.375 9.14961C16.375 9.63711 16.75 10.0121 17.2375 10.0121H19.7875L17.8 11.7371H12.8875C12.625 11.7371 12.3625 11.8496 12.2125 12.0746L9.55 15.5621H5.6125C5.1625 15.5621 4.75 15.9371 4.75 16.4246C4.75 16.9121 5.125 17.2871 5.6125 17.2871H9.9625C10.225 17.2871 10.4875 17.1746 10.6375 16.9496L13.3 13.4621H18.1375C18.325 13.4621 18.55 13.3871 18.7 13.2371L21.175 11.0621V13.9496C21.175 14.3996 21.55 14.8121 22.0375 14.8121C22.525 14.8121 22.9 14.4371 22.9 13.9496V9.48711C22.8625 8.84961 22.3 8.28711 21.625 8.28711Z"
        fill="currentColor"
      />
    </svg>
  );
}
